export const isConcept = (v) => typeof v === 'object' &&
    v !== null &&
    typeof v.id === 'string' &&
    typeof v.code === 'string' &&
    typeof v.name === 'string' &&
    typeof v.active === 'boolean' &&
    Number.isInteger(v.version);
export const isConceptsResponse = (v) => typeof v === 'object' &&
    v !== null &&
    Array.isArray(v.items) &&
    v.items.every(isConcept) &&
    Array.isArray(v.categories);
export const isConceptResponse = (v) => typeof v === 'object' && v !== null && isConcept(v.concept);
